import { synthesizeCatalogFromPresentation } from './adapters';

export const state = {
    // Indicator catalog, from the LIVE GET /risk endpoint merged with
    // riskPresentation.js. See adapters.js#normalizeCatalog.
    //
    // Seeded synchronously from presentation-only data (not []) so
    // `activeIndicator`/`threshold` resolve correctly from the very first
    // render, before the live GET /risk call has a chance to complete.
    // Without this, a fetch fired from Risk.vue's mounted()/watch — which
    // happens immediately, not after fetchCatalog resolves — sees
    // activeIndicator === null, so the `threshold` getter falls back to
    // null, Number(null) coerces to 0 downstream, and threshold (a
    // REQUIRED field on the real /api/v1/risk/probability contract) goes
    // out wrong. fetchCatalog's success handler overwrites this with the
    // server-confirmed catalog once it resolves; for freeze/chill_hours the
    // value doesn't even change (presentation defaults already win there —
    // see adapters.js#normalizeCatalog), so there's no visible flicker.
    catalog: synthesizeCatalogFromPresentation(),
    catalogStatus: 'idle', // idle | loading | ready | error
    catalogError: null,

    indicator: 'freeze',
    units: 'F',
    // Threshold persists PER indicator (not a single scalar) so switching
    // Freeze -> Drought Index -> Freeze returns to 28, not 0.5.
    thresholdByIndicator: {},
    // Direction persists PER indicator too, same reasoning — only the Drought
    // Index (arid) reads this (riskPresentation.js#opSelectable); see
    // getters.js#op, which falls back to the active indicator's defaultOp.
    opByIndicator: {},
    // Heat Index level per indicator, same reasoning — only `hi` reads it
    // (riskPresentation.js#categorySelectable); see getters.js#category.
    categoryByIndicator: {},
    // Minimum daily exposure hours per indicator — only the heat index reads it
    // (riskPresentation.js#minHoursSelectable); see getters.js#minHours.
    minHoursByIndicator: {},

    status: 'idle', // idle | loading | ready | empty | error
    data: null,
    error: null,
    lastParams: null,

    // Client cache keyed by (indicator, lat, lon, start, end, aggregation,
    // threshold, units, op) — see actions.js#cacheKey.
    cache: {},
    cacheOrder: [],
};
